module.exports = __webpack_public_path__ + "img/Group 1022four.bfb6dafa.png";